// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errors":"ValidationErrorMessage-be07126d0ef36250","error":"ValidationErrorMessage-899dd01bfee2fce8"};